module.exports = __webpack_public_path__ + "img/2.cfbc2e27.jpg";